import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import PrivateLayout from '../../layouts/privateLayout';
import { Box, Container, Link } from '@mui/material';
import BasicBreadcrumbs from '../../components/breadcrumb';
import ValueTagHeaderForm from './valueTagHeaderForm';
import { valueTagSet, valueTagsList } from '../../data/valueTagData';
import { Link as RouterLink } from "react-router-dom";
import { useApiClient } from "../../context/ApiClientContext";
import api from '../../helper/baseApi';
import ErrorAlert from '../../helper/errorAlert';

const ValueTagDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const [mode, setMode] = useState('view');
  const [dataList, setDataList] = useState([]);
  const [detailsList, setDetailsList] = useState([]);
  const [isLoading, setLoading] = React.useState(false);
  const navigate = useNavigate();
  const { apiUrls: { mobileApiUrl } } = useApiClient();

  const fetchData = async () => {
    try {
      const apiUrl = `${mobileApiUrl}valueTag/details?headerId=${id}`;
      const response = await api.get(apiUrl);

      const valueTag = response.data.data; // single object
      const valueDetail = response.data.data.valueTagDetails;

      const data = {
        ...valueTag,           // keep all fields (description, iconCode, etc.)
        id: valueTag.valueTagId, // alias so you can use "id" consistently
        name: valueTag.name      // make sure name is easy to use
      };

      setDetailsList(valueDetail);
      setDataList([data]);
    } catch (error) {
      // ErrorAlert(error, navigate);
    }
  };

  useEffect(() => {
    if (location.pathname.includes("edit-valuetag")) {
      setMode("edit");
      fetchData();
    } else if (location.pathname.includes("view-valuetag")) {
      setMode("view");
      fetchData();
    } else {
      setMode("create");
    }
  }, [location.pathname]);

  const valueTagHeaderDetails = dataList.length > 0 ? dataList[0] : null;

  return (
    <PrivateLayout>
      <Box sx={{ mx: "40px", mt: 5 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
            mb: 3,
          }}
        >
          <Box display="flex" justifyContent="start" alignItems="center">
            <BasicBreadcrumbs
              first={
                <Link component={RouterLink} to="/value-tag" underline="hover" color="primary.main">
                  Value Tag System
                </Link>
              }
              second={mode === "view" ? "View" : mode === "edit" ? "Edit" : "Add"}
            />

            <Box sx={{ display: "flex" }}></Box>
          </Box>
        </Box>
        <Box px={3} sx={{ width: "100%" }}>
          <ValueTagHeaderForm
            mode={mode}
            valueTagHeaderDetails={valueTagHeaderDetails}
            valueTagSet={detailsList}
            onModeChange={setMode}
            onRefetch={fetchData} />
        </Box>
      </Box>
    </PrivateLayout>
  )
}

export default ValueTagDetails